export class TipOption {
    label: string;
    value: number;
}

export class OrderTip {
    subtotal: number;
    percent: string;
    isCustom: boolean;
    inputed: string;
    basketId: string;
}
